<template>
  <div class="main-content" :class="data.class">
    <div v-if="data.superHeader" class="table-header table-super-header">
      <div class="table-gabarit">
        <component :is="spec.type ? spec.type : 'raw-data'" v-for="(spec, idx) in data.superHeader" :key="idx" :class="[spec.className]" :data="spec">
        </component>
      </div>
    </div>
    <div v-if="data.specifications" :class="['table-header', { bordered: data.specifications }]">
      <div class="table-gabarit">
        <component :is="spec.type ? spec.type : 'raw-data'" v-for="(spec, idx) in data.specifications" :key="idx" :class="[spec.className]" :data="spec">
        </component>
      </div>
    </div>
    <div class="table-body">
      <div
        v-for="(row, mainIdx) in entries"
        :key="row.id || (row.length >= 0 ? row[0].address : null) || mainIdx"
        class="table-row"
        :class="{
          active: mainIdx === index,
          'current-site-row': row && row[0] && row[0].className && row[0].className.includes('current-site'),
        }"
      >
        <div class="table-gabarit">
          <component :is="item.type ? item.type : 'raw-data'" v-for="(item, idx) in row" :key="idx" :forcedTransport="forcedTransport" :data="item">
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentSite from './CurrentSite';
import Heading from './Heading';
import RawData from './RawData';
import Site from './Site';
import SubHeader from './SubHeader';
import SummaryImpact from '@/components/Map/Analysis/Summary/Impact';
import UiBlock from './UiBlock';

export default {
  components: {
    CurrentSite,
    Heading,
    RawData,
    Site,
    SubHeader,
    SummaryImpact,
    UiBlock,
  },

  props: {
    data: {
      type: Object,
    },

    index: {
      type: Number,
      default: -1,
    },

    scrollIndex: {
      type: Number,
      default: 0,
    },

    forcedTransport: {
      type: String,
      default: '',
    },
  },

  computed: {
    entries() {
      return [...this.data.entries.filter((e, i) => i >= this.scrollIndex), ...this.data.entries.filter((e, i) => i < this.scrollIndex)];
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';

.main-content {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 6.5em;
  flex: 1;
  margin-left: -4.375em;
  margin-right: -4.375em;

  .table-header {
    height: 4.875em;
    display: flex;

    &:not(.table-super-header) {
      border-bottom: solid 1px #e3e3e3;
    }

    &.table-super-header {
      height: 9.375em;

      .value-block:not(.super-header) {
        flex: none;
        color: #b1b2b4;
        font-size: 2.5em;

        .caption {
          font-size: 1.1em;
          color: white;
        }
      }
      .super-header {
        margin-left: 4px;
        font-weight: 600;
        color: #3c3c3b;
        font-size: 1.5em;
        text-align: left;
      }
      .td:nth-child(2) {
        border-right: 0;
      }
    }
    .table-gabarit {
      min-height: 32px;

      .value-block {
        font-size: 2.75em;
        small {
          font-size: 0.7272727273em;
        }
      }
    }
  }
  .table-gabarit {
    margin-left: 4.375em;
    margin-right: 4.375em;
    flex: 1;
    align-items: center;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;

    .td:first-child {
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        flex: 0 1 auto;
        width: 256px;
      }
    }
  }
  .heading {
    font-size: 2em;
  }
  .value-block {
    font-size: 4.375em;
    flex: 1;
    text-align: center;

    &.current-site {
      display: flex;
      justify-content: center;
      height: 48px;
      padding: 8px 0;
      margin: -1px 0 0;
      font-weight: 600 !important;
      box-sizing: border-box;

      &.site {
        width: 236px;

        &.empty {
          border-color: transparent;
        }
      }
    }
    i {
      font-size: 0.875em;
    }
    small {
      font-size: 0.4571428571em;
      i {
        font-size: 1em;
      }
    }
    & + .value-block {
      flex: 1;
    }
  }
  .table-body {
    flex: 1;
    display: flex;
    flex-direction: column;

    .table-row {
      min-height: 78px;
      flex: 0 1 25%;
      display: flex;
      transition: background-color 0.3s ease;

      & + .table-row {
        .table-gabarit {
          border-top: 1px solid colors.$dark-concrete-color;
        }
      }
      &:nth-child(n + 5) {
        display: none;
      }
      &.active {
        background-color: colors.$light-stone-color;
      }
      &.current-site-row {
        min-height: 48px;
      }
    }
  }
}
.td {
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;

  &.big {
    flex: 2;
  }
  &.ui {
    flex: 0.5;
  }
  .table-header & {
    align-items: center;
    justify-content: center;
  }
}

.average {
  .td:nth-child(2) {
    border-right: solid 1px #e3e3e3;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .main-content .table-body {
    display: block !important;
    flex: none !important;
  }
}
</style>
